import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";

import lawnMowing from "../../../assets/img/freshly-mowed-lawn-bur-han.jpg";
import lawnEdging from "../../../assets/img/lawn-health.jpg";

export default function WeeklyLawnCutting() {
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Weekly Lawn Cutting Service in Vancouver & Surrounding Areas | BUR-HAN";
    document.title = newTitle;

    const newDescription = "Professional weekly lawn mowing service in Vancouver, North Van, West Van & Burnaby. Eco-friendly, reliable cutting with full edging & cleanup included.";
    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "weekly lawn mowing Vancouver",
      "professional lawn cutting service",
      "eco-friendly lawn care",
      "North Vancouver lawn maintenance",
      "West Vancouver lawn service",
      "Burnaby weekly mowing",
      "battery-powered lawn mowing",
      "quiet lawn equipment",
      "no contract lawn care",
      "best lawn cutting service",
      "reliable lawn maintenance",
      "pet-safe lawn care",
      "lawn edging service",
      "BUR-HAN lawn care",
      "local lawn mowing company"
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost weeklyCutting">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                Weekly Lawn Cutting Service in Vancouver
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                & Surrounding Areas
              </div>
            </h1>
            <p className="lead" data-aos="fade-right">
              Enjoy a Greener, Healthier Lawn—Every Week
            </p>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              For over 30+ years, BUR-HAN Garden & Lawn Care has helped homeowners in Vancouver, 
              North Vancouver, West Vancouver, Burnaby, and surrounding communities enjoy beautiful, 
              worry-free lawns. Our expert team delivers consistent, eco-friendly lawn cutting—using 
              quiet, battery-powered equipment for your comfort and the environment.
            </p>
            
            <img loading="lazy"
              src={lawnMowing}
              alt="Professional lawn mowing service in action"
              title="Weekly Lawn Cutting Service"
              className="img-responsive"
            />

            <h2>Why Vancouver Homeowners Trust BUR-HAN</h2>
            <p>
              <span>30+ Years of Local Experience</span><br />
              Serving the Lower Mainland since 1995 with a reputation for reliability and quality.
            </p>
            <p>
              <span>Weekly Service—No Contracts Required</span><br />
              We offer dedicated weekly mowing for optimal lawn health and curb appeal—no need to commit long-term.
            </p>
            <p>
              <span>Eco-Friendly, Quiet Equipment</span><br />
              All-electric, low-noise mowers and trimmers keep your neighborhood peaceful and reduce emissions.
            </p>
            <p>
              <span>Meticulous, Professional Care</span><br />
              Every visit includes precise mowing, edging, trimming, and full cleanup—leaving your property spotless.
            </p>
            <p>
              <span>Family & Pet Safe</span><br />
              We use pesticide-free, sustainable practices for a lawn everyone can enjoy.
            </p>

            <h2>What's Included</h2>
            <ul>
              <li>Weekly mowing to the ideal height for healthy growth</li>
              <li>Edging along walkways, driveways, and garden beds</li>
              <li>Trimming around trees, fences, and hard-to-reach spots</li>
              <li>Blowing and removal of all grass clippings and debris</li>
              <li>Visual lawn health inspection at every visit</li>
            </ul>

            <img loading="lazy"
              src={lawnEdging}
              alt="Professional edging service for crisp lawn edges"
              title="Precision Lawn Edging"
              className="img-responsive"
            />
         
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/how-often-mow-lawn-vancouver">How Often Should You Mow Your Lawn in Vancouver?</a></li>
            <li><a href="/blog/mastering-the-art-of-lawn-mowing-tips-for-a-healthy-vibrant-lawn">Mastering the Art of Lawn Mowing</a></li>
            <li><a href="/blog/the-benefits-of-a-professional-lawn-cutting-service-in-vancouver">The Benefits of a Professional Lawn Cutting Service</a></li>
            <li><a href="/blog/spring-lawn-care-checklist-vancouver">Spring Lawn Care Checklist for Greater Vancouver Homeowners</a></li>
          </ul>
        </div>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our contact page, and let our expert landscaping team
                  bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs.
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}